export default "__VITE_ASSET__BxMjRsLX__"